


































import { mapState } from 'vuex'
import { CLASSIFIED_VIEW_NS } from '~/store/modules/shared/classifieds/view/state'
import { ClassifiedDiscount, PricePerUnit } from '~/models/classified/types'
import CPrice from '~/components/shared/configurable/CPrice.vue'
import { defineComponent, PropType } from '@nuxtjs/composition-api'

export default defineComponent({
  components: { CPrice },
  props: {
    pricePerUnit: {
      type: Object as PropType<PricePerUnit>,
      default: null
    },
    price: {
      type: Object,
      required: true
    },
    discount: {
      type: Object as PropType<ClassifiedDiscount>,
      default: null
    },
    externalLink: {
      type: Object,
      default: null
    }
  },
  computed: {
    ...mapState(CLASSIFIED_VIEW_NS, {
      categoryIds: state => state.classified.category_ids,
      classifiedId: state => state.classified.id
    }),
    extraLabel() {
      const { extra } = this.price
      if (extra.foreign_numbers) {
        return this.$t('foreign number plate')
      } else if (extra.without_vat && !extra.ask_price) {
        return this.$t('without vat')
      }
      return null
    }
  }
})
